import React from "react";
import { useApp } from "../../context/AppContext";
import api from "../../api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Download } from "lucide-react";

const REPORTS = ["journal", "trial-balance", "vat-sales", "vat-purchases"];

export const ExportMenu = () => {
  const { t, entity } = useApp();
  const year = new Date().getFullYear();
  const q = `Q${Math.floor(new Date().getMonth() / 3) + 1}`;
  const dl = async (report, fmt) => {
    try {
      const res = await api.get(`/export/${report}`, { params: { entity_id: entity, fmt, year, period: q }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${report}-${entity}-${year}.${fmt}`; a.click(); URL.revokeObjectURL(url);
      toast.success(t("exp.done"));
    } catch { toast.error(t("msg.error")); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild><Button variant="outline" data-testid="export-menu-button"><Download className="h-4 w-4 mr-2" />{t("exp.title")}</Button></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72" data-testid="export-menu">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{t("exp.hint")} ({year} · {q})</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {REPORTS.map((r) => (
          <div key={r} className="flex items-center justify-between px-2 py-1 text-sm">
            <span>{t(`exp.${r}`)}</span>
            <span className="flex gap-1">
              <DropdownMenuItem className="px-2 py-0.5 text-xs font-mono cursor-pointer" onSelect={() => dl(r, "pdf")} data-testid={`export-${r}-pdf`}>PDF</DropdownMenuItem>
              <DropdownMenuItem className="px-2 py-0.5 text-xs font-mono cursor-pointer" onSelect={() => dl(r, "xlsx")} data-testid={`export-${r}-xlsx`}>XLSX</DropdownMenuItem>
            </span>
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
